export default "__VITE_ASSET__1HzxMTI0__"